export const PLAYPAUSE = "PLAYPAUSE"
export const CHANGETRACK = "CHANGETRACK"

export const changePlay = (trackKey) => ({
  type: PLAYPAUSE,
  payload: trackKey,
})

export const changeTrack = (trackKey) => ({
  type: CHANGETRACK,
  payload: trackKey,
})
